const e = {
  "explore-list-items-title": "Categorias mais buscadas",
  "comment-input-blocked-placeholder": "Comentários bloqueados",
  "comment-input-edit-placeholder": "Edite seu comentário",
  "comment-input-comment-placeholder": "Deixe o seu comentário",
  "comment-input-answer-placeholder": "Deixe a sua resposta",
  "comment-input-submit-button-aria-label": "Enviar comentário",
  "comment-avatar-alt-text": "imagem de perfil do usuário",
  "comment-avatar-alt-text-anonymous": "Anônimo",
  "comment-text-area-aria-label": "Campo de comentário",
  "comment-image-button-error": "Erro ao fazer upload da imagem. Tente novamente mais tarde",
  "comment-image-button-title": "adicionar imagem",
  "comment-suggestions-carousel-back-button": "Sugestões anteriores",
  "comment-suggestions-carousel-forward-button": "Próximas sugestões",
  "comment-actions-like-button-title": "curtir",
  "comment-actions-reply-button-title": "Responder",
  "comment-actions-reply-button-icon-aria-label": "ícone de comentario",
  "comment-actions-react-button-title": "Reagir",
  "comment-actions-remove-react-button-title": "Remover reação {0}",
  "comment-actions-funny-label": "de engraçado",
  "comment-actions-helpful-label": "de útil",
  "comment-actions-like-label": "de like",
  "comment-actions-funny-text": "Haha",
  "comment-actions-helpful-text": "Útil",
  "comment-actions-like-text": "Like",
  "comment-reaction-counter-title": "Visualizar quantidade de reações",
  "comment-actions-counter-funny-icon": "Ícone de engraçado",
  "comment-actions-counter-helpful-icon": "Ícone de útil",
  "comment-actions-counter-like-icon": "Ícone de like",
  "deal-header-store-label": "Promoção",
  "deal-header-dropdown-title": "mais opções",
  "deal-image-alt-text": "Foto do produto",
  "deal-description-image-alt-text": "Imagem na descrição da promoção",
  "deal-stamp-currency": "R$",
  "deal-stamp-free": "Grátis",
  "deal-stamp-free-shipping": "Frete Grátis",
  "deal-button-title": "Ir pra Loja",
  "deal-button-cupom-title": "Pegar cupom",
  "deal-button-label-text": "Abrir em uma nova aba",
  "deal-action-bar-comment-button-title": "Comentários",
  "deal-action-bar-vote-button-title": "Esfriar / Esquentar",
  "deal-vote-button-undo-title": "desfazer",
  "deal-vote-button-remove-vote-title": "Remover voto",
  "deal-vote-button-cold-down-title": "esfriar",
  "deal-vote-button-warm-up-title": "esquentar",
  "deal-whatsapp-button": "Compartilhar",
  "deal-whatsapp-icon-aria-label": "ícone de whatsapp",
  "deal-description-title-mobile": "Descrição",
  "deal-description-title-desktop": "Saiba mais sobre essa promoção",
  "deal-description-published-by": "Publicado por",
  "auto-generated-description": "Complemento do Pelando",
  "nickname-top-creator-icon-label": "ícone de top creator",
  "follow-user-button": "Seguir",
  "follow-user-button-following": "Seguindo",
  "follow-user-button-follow-back": "Seguir de volta",
  "expand-button-expand-text": "Ver mais",
  "expand-button-compress-text": "Ver menos",
  "copy-button-label-text": "Copiar",
  "copy-link-button-label-text": "Copiar link",
  "copied-link-button-label-text": "Link copiado com sucesso!",
  "save-button-label": "Salvar",
  "saved-button-label": "Salvo",
  "save-button-title": "Salvar promoção",
  "unsave-button-title": "Remover promoção salva",
  "hot-deals-carousel-title": "Promoções Pelando",
  "hot-deals-carousel-description": "As mais quentes da comunidade",
  "hot-deals-carousel-back-button-label": "Promoções anteriores",
  "hot-deals-carousel-forward-button-label": "Próximas promoções",
  "hot-deal-comments-label": "comentários",
  "notification-bar-title": "Notificações",
  "notification-bar-read-all-button": "Marcar tudo como lido",
  "go-to-back-button-aria-label": "Voltar",
  "notification-bar-list-empty-state": "Você não possui notificações.",
  "notification-bar-item-aria-label-unread": "notificação não lida",
  "notification-bar-item-aria-label-read": "notificação lida",
  "notification-bar-bell-icon": "ícone de notificação",
  "load-more-button-loading": "carregando...",
  "load-more-button": "Carregar mais",
  "continue-button": "Continuar",
  "header-alert-text": "Alerta para",
  "profile-header-reactions-text": "Reações em comentários",
  "profile-header-reactions-icon-label": "ícone de reações",
  "profile-header-reactions-icon-label-like": "ícone de likes",
  "profile-header-avatar-text": "avatar do usuário",
  "profile-header-edit-nickname-aria-label": "editar nickname",
  "profile-header-icon-calendary-aria-label": "ícone de calendário",
  "profile-header-icon-fire-flame-aria-label": "ícone fogo",
  "profile-header-icon-tags-aria-label": "ícone de promoções",
  "profile-header-icon-temperature-high-aria-label": "ícone de promoção mais quente",
  "profile-header-icon-hands-clapping-aria-label": "ícone de agradecimentos",
  "profile-header-member-since": "Membro desde",
  "profile-header-member-internal": " Time Pelando",
  "profile-header-total-promotions": " Promoções",
  "profile-header-total-high-promotion": " Promoção mais quente",
  "profile-header-total-grateful": " Agradecimentos",
  "profile-header-total-followed": " Seguidores",
  "profile-header-total-following": " Seguindo",
  "profile-header-follow-button": " Seguir",
  "profile-header-my-data-button": "Meus dados",
  "avatar-edit-aria-label": "editar avatar",
  "floating-tag-icon-aria-label": "ícone de menssagem",
  "deal-action-button-aria-label": "Ir pra loja",
  "secondary-deal-card-store-image-text": "Imagem da loja",
  "best-price-badge-text": "Melhor preço hoje",
  "secondary-deal-card-product-image-text": "Imagem do produto",
  "secondary-deal-card-community-deal": "Cupom sugerido pela comunidade",
  "secondary-deal-card-go-to-store-button": "Ir pra loja",
  "secondary-deal-card-community-tag": "Promoção publicada pela comunidade!",
  "secondary-deal-card-see-deal-link": "Ver detalhes da promoção",
  "deal-saved-notification-label": "Notificações",
  "deal-saved-notification-label-actived": "ativadas",
  "deal-saved-notification-label-disabled": "desativadas",
  "deal-saved-button-label-to-save": "Salvar",
  "deal-saved-button-label-stop-saving": "Deixar de salvar",
  "deal-store-label": "| Vendido por",
  "deal-store-label-verified": "Loja verificada",
  "link-modal-icon": "ícone de link",
  "link-modal-title": "Adicionar Link",
  "link-modal-text": "Texto:",
  "link-modal-placeholder-text": "Ex.: Google",
  "link-modal-address": "Endereço:",
  "link-modal-placeholder-address": "Ex.: www.google.com",
  "link-modal-button-submit": "Adicionar",
  "link-modal-error-message": "Link inválido! Confira o endereço.",
  "select-image-input-alt": "imagem do produto",
  "select-image-input-icon-check-aria-label": "ícone de selecionado",
  "select-image-input-change-label": "alterar",
  "select-image-input-icon-image-aria-label": "ícone de imagem",
  "select-image-input-upload-label": "inserir imagem",
  "select-image-input-send-alt": "imagem enviada",
  "new-store-card-coupon-count-label": "Cupons",
  "new-store-card-product-count-label": "Produtos na loja",
  "new-store-card-deal-count-label": "Promoções ativas",
  "new-store-card-coupon-count-label-singular": "Cupom",
  "new-store-card-product-count-label-singular": "Produto na loja",
  "new-store-card-deal-count-label-singular": "Promoção ativa",
  "new-store-card-button-label": "Abrir loja",
  "grid-product-card-hot-tag": "Tá Pelando",
  "grid-product-card-price-text": "A partir de",
  "grid-product-card-stores-text": "Compare entre",
  "grid-product-card-price": "R$",
  "contextual-alert-box-title": "Crie um alerta de desejo",
  "contextual-alert-box-icon": "ícone de bandeira",
  "contextual-alert-box-subtitle": "E avisamos quando houver promoção",
  "hot-tag": "Tá Pelando",
  "product-card-image-alt": "Imagem do produto",
  "product-card-store-with-best-price": "Menor preço via ",
  "deal-feed-card-actions-comment-button": "comentários",
  "deal-feed-card-actions-see-deal-mobile": "Ver mais",
  "deal-feed-card-actions-see-deal-desktop": "Ver promoção",
  "store-card-button": "Abrir loja",
  "store-card-tab-coupons": "Cupons",
  "store-card-tab-deals": "Promoções",
  "deal-card-coupon-stamp-price": "R$",
  "deal-card-coupon-stamp-free-shipping": "Frete Grátis",
  "deal-card-coupon-stamp-shipping": "Frete",
  "deal-card-coupon-stamp-free": "Grátis",
  "grid-product-card-stores-singular": "loja",
  "grid-product-card-stores": "lojas",
  "deal-body-empty-state-title": "Faça uma pergunta sobre a promo!",
  "deal-body-empty-state-subtitle": "Ops, essa promoção não tem descrição.",
  "new-comment-flag": "novo comentário",
  "publishing-comment-flag": "publicando...",
  "moderated-comment-flag": "em análise",
  "deleted-comment-flag": "deletado",
  "reactions-popover-like": "Like",
  "reactions-popover-funny": "Haha",
  "reactions-popover-helpfull": "Útil",
  "comment-options-title": "Opções",
  "comment-options-icon-label": "ícone de mais opções",
  "parent-comment-header": "Comentário deletado",
  "deleted-content": "comentário deletado",
  "retracted-content-read-more": "Ler mais",
  "retracted-content-read-less": "Ler menos",
  "store-label-verified": "LOJA VERIFICADA",
  "blog-pagination-current-page-label": "Página atual, página",
  "blog-pagination-page-label": "Ir para a página",
  "link-preview-image-alt": "Imagem de ",
  "link-preview-belete-button": "Remover marcação de link",
  "list-item-aria-label": "Selecionado",
  "loading-text": "Carregando...",
  "close-buttton-aria-label": "Fechar",
  "pagination-first-page-aria-label": "Primeira página",
  "pagination-previus-page-aria-label": "Página anterior",
  "pagination-next-page-aria-label": "Próxima página",
  "pagination-last-page-aria-label": "Última página",
  "pagination-arrow-left-aria-label": "seta esquerda",
  "pagination-page-controller": "página",
  "pagination-page-controller-previus": "anterior",
  "pagination-page-controller-next": "próxima",
  "password-input-visibility-label-show": "Mostrar senha",
  "password-input-visibility-label-to-hide": "Esconder senha",
  "password-input-placeholder": "Digite sua senha",
  "small-product-card-image-aria-label": "Imagem do produto",
  "small-store-card-alt": "logo da loja",
  "text-input-success-message-aria-label": "ícone de sucesso",
  "text-input-error-message-aria-label": "ícone de erro",
  "text-input-tip-message-aria-label": "ícone de dica",
  "text-input-alert-message-aria-label": "ícone de alerta",
  "expand-buton-aria-label": "Mostrar descrição",
  "user-menu-title": "Menu usuário",
  "tip-badge-aria-label": "ícone de dica do pelando",
  "tip-badge-text": "dica pelando",
  "top-badge-aria-label": "ícone de top comentário",
  "top-badge-text": "top comentário",
  "like-button-aria-label": "ícone de curtir",
  "header-verified-author-title": "Acessar perfil do autor da promoção",
  "header-verified-author-alt": "Avatar do autor da promoção",
  "label-by-status-deleted": "Deletada",
  "label-by-status-expired": "Expirada",
  "label-by-status-moderated": "Moderada",
  "label-by-status-pending": "Pendente",
  "default-feed-timestamp-title": "Hora da publicação",
  "feed-card-actions-comment": "comentários",
  "open-deal-mobile-text": "Abrir",
  "open-deal-big-screen-text": "Abrir promoção",
  "deal-deleted-card-know-more": "Saiba mais",
  "deal-deleted-card-contact": "Fale com o Pelando",
  "dropdown-title": "Abrir dropdown",
  "rating-star-value-one": "Votar 1 estrela",
  "rating-star-value": "Votar {0} estrelas",
  "normalize-value-remove-vote": "Remover voto",
  "normalize-value-no-vote": "Nenhum voto",
  "normalize-value-one-star": "1 estrela",
  "normalize-value-stars": "estrelas",
  "normalize-value-stars-vote": "Votar",
  "clear-format-button-text": "limpar estilo",
  "emoji-categories-smileys-people": "Carinhas & Pessoas",
  "emoji-categories-animals": "Animais & Natureza",
  "emoji-categories-food-drink": "Comida & Bebida",
  "emoji-categories-activities": "Atividade",
  "emoji-categories-travel-places": "Viagem & Locais",
  "emoji-categories-objects": "Objetos",
  "emoji-categories-symbols": "Símbolos",
  "emoji-add-aria-label": "adicionar emoji",
  "emoji-button-aria-label": "rosto sorrindo",
  "helpful-comment-edited": "editado",
  "history-buttons-undo": "desfazer",
  "history-buttons-remake": "refazer",
  "link-button-title": "adicionar link",
  "list-button-unordered": "lista não ordenada",
  "list-button-ordered": "lista ordenada",
  "loading-editor": "carregando",
  "format-button-bold": "negrito",
  "format-button-italic": "italico",
  "format-button-strike": "traçado",
  "super-cashback-percentage-tag-text": "de cashback"
};
export {
  e as default
};
